import { sortBy } from "es-toolkit/compat";

export function sortByOrder<T>(array: T[], key: keyof T, order: T[keyof T][]): T[] {
  return sortBy(array, (item) => {
    const index = order.indexOf(item[key]);
    return index === -1 ? array.length : index;
  });
}
